module.exports = __webpack_public_path__ + "media/images/s01_01-eb4672ccf2fd0dd7d31098f3dbb097e8.svg";